import React from "react";
import FeaturedPostCard from "./FeaturedPostCard";

const FeaturedPostCardSwitcher = (props: any) => {
  return (
    <FeaturedPostCard
      internalName={props.internalName}
      featuredBlogPost={props.featuredBlogPost}
      key={"FeaturedPost"}
    />
  );
};

export default FeaturedPostCardSwitcher;
